import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';
import RequestService from '@tcc-online/request-service';
import { NotificationActions } from '../../common/actions/NotificationActions';
import { StorageService } from '../../services';
import ImportProcess from '../../common/types/ImportProcess';

const ImportService = {
    confirmImport,
    cancelImport,
    getImportProgress,
    saveImportId,
    getImportId,
    deleteImportId,
};

async function confirmImport(importId: number, thunkApi: GetThunkAPI<any>) {
    try {
        const result = await RequestService.post<any, ImportProcess>(
            `/imports/${importId}/confirm`,
        );

        if (result.data?.errors?.length) {
            throw new Error();
        }

        return result;
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se importovat soubor'),
        ); // TODO: translate

        throw e;
    }
}

async function cancelImport(importId: number, thunkApi: GetThunkAPI<any>) {
    try {
        const result = await RequestService.post(`/imports/${importId}/cancel`);

        deleteImportId();

        return result;
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se zrusit import'),
        ); // TODO: translate

        throw e;
    }
}

async function getImportProgress(importId: number, thunkApi: GetThunkAPI<any>) {
    try {
        const result = await RequestService.get(
            `/admin/user/import/${importId}`,
        );

        if (result.data?.errors?.length) {
            throw new Error();
        }

        if (result.data?.status === 'completed') {
            deleteImportId();
            thunkApi.dispatch(
                NotificationActions.success('import proběhl uspesne'),
            ); // TODO: translate
        }

        return result;
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se importovat uzivatele'),
        ); // TODO: translate

        throw e;
    }
}

const IMPORT_KEY = 'TCC_ONLINE__IMPORT_ID';

function saveImportId(importId: number) {
    StorageService.setLocal(IMPORT_KEY, importId);
}

function getImportId(): number | null {
    return StorageService.getLocal<number | null>(IMPORT_KEY, null);
}

function deleteImportId() {
    StorageService.deleteLocal(IMPORT_KEY);
}

export default ImportService;
